"use client";

import dynamic from "next/dynamic";

const VideoRotationDemoLazy = dynamic(() => import("./VideoRotationDemo").then(mod => mod.VideoRotationDemo));

export default VideoRotationDemoLazy;
